var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { calculatePosition, getClientRect, movePositionWithinContainer } from "../../utils/tooltip";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
import { IdTooltipAnchor } from "./IdTooltipAnchor";
import { TooltipModal } from "./TooltipModal";
import { TooltipTrigger } from "./TooltipTrigger";
export var TooltipText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = props.anchor, anchor = _b === void 0 ? IdTooltipAnchor.Bottom : _b, safe = props.safe, adjustHorizontal = props.adjustHorizontal, adjustVertical = props.adjustVertical, className = props.className, id = props.id;
    var _c = React.useState(undefined), tooltipStyle = _c[0], setTooltipStyle = _c[1];
    // tslint:disable-next-line:no-null-keyword
    var _d = React.useState(null), componentRef = _d[0], setComponentRef = _d[1];
    // tslint:disable-next-line:no-null-keyword
    var contentRef = React.useRef(null);
    React.useEffect(function () {
        var defaultPosition = { top: 0, left: 0, minWidth: 0 };
        var tooltipStyleRef = componentRef && contentRef && contentRef.current
            ? calculatePosition(0, anchor, getClientRect(contentRef), componentRef.getBoundingClientRect())
            : defaultPosition;
        var makeSafe = movePositionWithinContainer(window.innerWidth, window.innerHeight);
        if (safe) {
            makeSafe(tooltipStyleRef);
        }
        if (adjustHorizontal) {
            tooltipStyleRef.left += adjustHorizontal;
        }
        if (adjustVertical) {
            tooltipStyleRef.top += adjustVertical;
        }
        tooltipStyleRef.top = utilNumber.roundToPrecision(tooltipStyleRef.top, 2);
        tooltipStyleRef.left = utilNumber.roundToPrecision(tooltipStyleRef.left, 2);
        tooltipStyleRef.minWidth = utilNumber.roundToPrecision(tooltipStyleRef.minWidth, 2);
        setTooltipStyle(tooltipStyleRef);
    }, [componentRef]);
    return (React.createElement(TooltipTrigger, null, function (visible) {
        return (React.createElement(React.Fragment, null,
            visible && tooltipStyle && id && (React.createElement(TooltipModal, null,
                React.createElement("span", { style: tooltipStyle, className: "tooltip__text tooltip__text--" + anchor + " tooltip--visible", ref: function (ref) {
                        setComponentRef(ref);
                    } },
                    React.createElement(TextLoca, __assign({}, props, { className: IdStyles.TextBoldPrimary }))))),
            React.createElement("div", { className: className },
                React.createElement("span", { ref: contentRef }, children))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/TooltipText.tsx
// module id = 662
// module chunks = 3